/**
 * Created by andrey on 04.07.17.
 */

cleverapps.CrossPromo = function () {
    this.load();

    this.promotion = [];
    connector.platform.whenConnected(() => this.updatePromotion());
    cleverapps.settings.on("updateLanguage", () => this.updatePromotion(), this);
};

cleverapps.CrossPromo.prototype.updatePromotion = function () {
    this.listPromotions().then((promotion) => {
        this.promotion = promotion;
    });
};

cleverapps.CrossPromo.prototype.havePromotion = function () {
    return connector.platform.canSwitchGame() && this.promotion && this.promotion.length
        && cleverapps.user.checkAvailable(cleverapps.config.availables.CROSS_PROMO);
};

cleverapps.CrossPromo.prototype.listTopGames = function () {
    const json = bundles.crosspromo.jsons.crosspromo_json.getJson();
    const priorities = json.priorities || {};

    return Object.keys(json).filter((key) => typeof json[key] === "object" && json[key].name)
        .sort((key1, key2) => ((priorities[key2] || 0) - (priorities[key1] || 0)) || key1.localeCompare(key2));
};

cleverapps.CrossPromo.prototype.load = function () {
    const data = cleverapps.dataLoader.load(DataLoader.TYPES.CROSSPROMO) || {};
    this.shownMarkDate = data.shownMarkDate;
};

cleverapps.CrossPromo.prototype.saveShownMarkTime = function () {
    this.shownMarkDate = Date.now();
    cleverapps.dataLoader.save(DataLoader.TYPES.CROSSPROMO, {
        shownMarkDate: this.shownMarkDate
    });
};

cleverapps.CrossPromo.prototype.getPlatformConfig = function (config) {
    const source = connector.info.source;

    switch (source) {
        case "macos":
            return config.ios;
        case "sp_mbga":
            return config.mbga;
        case "test":
            return {};
        case "cleverapps":
            return {};
        default:
            return config[source];
    }
};

cleverapps.CrossPromo.prototype.hasMark = function () {
    return this.havePromotion()
           && (!this.shownMarkDate
            || Date.now() - this.shownMarkDate >= cleverapps.CrossPromo.SHOW_MARK_INTERVAL);
};

cleverapps.CrossPromo.prototype.listPromotions = function () {
    const json = bundles.crosspromo.jsons.crosspromo_json.getJson();
    const priorities = json.priorities;

    const projects = Object.keys(json).filter((key) => typeof json[key] === "object" && json[key].name)
        .sort((key1, key2) => ((priorities[key2] || 0) - (priorities[key1] || 0)) || key1.localeCompare(key2));

    return connector.platform.listGames().then((gamesInfo) => {
        this.gamesInfo = gamesInfo || [];
        return projects.map((game) => this.createPromotion(game)).filter(Boolean);
    });
};

cleverapps.CrossPromo.prototype.createPromotion = function (game) {
    const json = bundles.crosspromo.jsons.crosspromo_json.getJson();

    if (game === cleverapps.config.name) {
        return;
    }

    const config = json[game];

    const platformConfig = this.getPlatformConfig(config);
    if (!platformConfig || !cleverapps.config.debugMode && platformConfig.debug) {
        return;
    }

    const bundleNameEn = `crosspromo_${game}_${cc.sys.LANGUAGE_ENGLISH}`;
    if (!bundles[bundleNameEn]) {
        return;
    }
    const bundleNameLocalized = `crosspromo_${game}_${cleverapps.settings.language}`;

    const bundleName = bundles[bundleNameLocalized] ? bundleNameLocalized : bundleNameEn;

    const promo = {
        id: game,
        title: `${game}PromoTitle`,
        description: `${game}Promo`,
        bundleName,
        link: connector.utils.guessPlatformURL({
            config,
            debugMode: false
        }),
        payload: undefined
    };

    if (!promo.link) {
        return;
    }

    switch (connector.info.source) {
        case "instant": {
            const projectBusiness = cleverapps.config.instant && cleverapps.config.instant.business || cleverapps.config.business;
            const promoBusiness = config.instant && config.instant.business || config.business;

            promo.link = config.instant && config.instant.appId;
            promo.payload = { channel: cleverapps.config.name };

            if (projectBusiness !== promoBusiness) {
                return;
            }
            break;
        }
        case "msstart":
            promo.link = config.msstart && config.msstart.appId;
            promo.payload = { channel: cleverapps.config.name };
            break;
        case "android":
            promo.link = cleverapps.addSearchParams(promo.link, {
                utm_campaign: cleverapps.config.name
            });
            break;
        case "yandex": {
            const appId = config.yandex && config.yandex.appId;
            const gameInfo = (this.gamesInfo || []).find((info) => info.appID === appId);
            if (!gameInfo) {
                return;
            }

            promo.link = cleverapps.addSearchParams(gameInfo.link, {
                payload: cleverapps.config.name
            });
            promo.imageURL = gameInfo.imageURL;
            break;
        }
        case "test":
            // a test stand points at the sibling game's stand, next door on localhost
            if (cleverapps.isLocalhost()) {
                promo.link = `${window.location.origin}/${game}/`;
            } else if (cleverapps.config.debugMode) {
                promo.link = cleverapps.config.deployment.replace(cleverapps.config.name, game);
            }
            break;
        default:
            promo.link = cleverapps.addSearchParams(promo.link, {
                channel: cleverapps.config.name
            });
            break;
    }

    return promo;
};

cleverapps.CrossPromo.OpenCrossPromoWindow = function () {
    if (!cleverapps.crossPromo.havePromotion()) {
        return;
    }

    const promotions = cleverapps.crossPromo.promotion;

    cleverapps.focusManager.display({
        focus: "CrossPromoWindow",
        stack: true,
        action: function (f) {
            new CrossPromoWindow(promotions);
            cleverapps.focusManager.onceNoWindowsListener = f;
        }
    });
};

cleverapps.CrossPromo.SHOW_MARK_INTERVAL = cleverapps.parseInterval(cleverapps.config.debugMode ? "20 minute" : "7 days");